// 路由配置
import Vue from 'vue'
import VueRouter from 'vue-router'
import { routers } from './router'
import http from './../utils/axios'

Vue.use(VueRouter)
// 路由配置
const RouterConfig = {
    // mode: 'history',
    routes: routers
}

const router = new VueRouter(RouterConfig)

function loadStorage(to, next) {
    sessionStorage.route = to.path
    if (to.name !== 'login') {
        http.get('/User/GetRouteProvinces?routeName=' + sessionStorage.route).then(response => {
            let allrouteProvince = response.data;
            let province = []
            allrouteProvince.forEach(function (value, index, array) {
                let p = {}
                p.label = value.ProvinceName
                p.value = value.ProvinceID
                province.push(p)
            })
            sessionStorage.province = province.length > 0 ? JSON.stringify(province) : null

            let allProvinceCityCounty = JSON.parse(localStorage.allProvinceCityCounty)

            let provinceCityCounty = []
            allProvinceCityCounty.forEach(function (value, index, array) {
                if (allrouteProvince.findIndex(item => item.RouteName === to.path && item.ProvinceID === value.value) > -1) {
                    provinceCityCounty.push(value)
                }
            })

           
            sessionStorage.provinceCityCounty = provinceCityCounty.length > 0 ? JSON.stringify(provinceCityCounty) : null

             let provinceCity = [];
            if (provinceCityCounty.length > 0) {
                provinceCityCounty.forEach(function (value, index, array) {
                    if (value.children && value.children.length > 0) {
                        if (value.children.length > 0) {
                            value.children.forEach(function (cityItem, cityIndex, cityArray) {
                                if (cityItem.children && cityItem.children.length > 0) {
                                    cityItem.children = [];
                                }
                            })
                        }
                        provinceCity.push(value);
                    }
                }
                )
            }
            sessionStorage.provinceCity = JSON.stringify(provinceCity);
            next();
        })
    }
    else {
        sessionStorage.province = [];
    }

}

router.beforeEach((to, from, next) => {
    if (to.matched.some(m => m.meta.requireAuth)) {
        let jurisdiction = false
        if (localStorage.routeAll) {
            localStorage.routeAll.split(',').forEach(function (value, index, array) {
                if (to.path === value) {
                    jurisdiction = true
                    return false
                }
            })
        }
        if (jurisdiction) {
            loadStorage(to, next)
        }
        else {
            if (to.path === '/login') {
                jurisdiction = true
            } else if (to.path === '/home/index') {
                jurisdiction = true
            } else if (to.path === '/') {
                jurisdiction = true
            }
            if (localStorage.tokenStorage === 'tokenStorage') {
                if (jurisdiction) {
                    next()
                } else {
                    if (to.fullPath === '/403') {
                        next()
                    } else {
                        next('/403')
                    }
                }
            } else {
                if (to.fullPath === '/login') {
                    next()
                } else {
                    next('/login')
                }
            }
        }
    } else {
        if (to.fullPath === '/404' || to.fullPath === '/loginJump') {
            next()
        } else {
            next('/404')
        }
    }
})
router.afterEach((to, from, next) => {
    // return next()
})
router.onError((error) => {
    const jsPattern = /Loading chunk (\S)+ failed/g
    const cssPattern = /Loading CSS chunk (\S)+ failed/g
    const isChunkLoadFailed = error.message.match(jsPattern || cssPattern)
    const targetPath = router.history.pending.fullPath
    if (isChunkLoadFailed) {

        localStorage.setItem('targetPath', targetPath)
        window.location.reload()
    }
})

router.onReady(() => {
    const targetPath = localStorage.getItem('targetPath')
    const tryReload = localStorage.getItem('tryReload')
    if (targetPath) {
        localStorage.removeItem('targetPath')
        if (!tryReload) {
            router.replace(targetPath)
            localStorage.setItem('tryReload', true)
        } else {
            localStorage.removeItem('tryReload')
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js